module.exports = __webpack_public_path__ + "img/C913.2dd495f0.jpg";